import { Link } from 'react-router-dom';
import { MapPin, Mail } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_engineering-turnkey/artifacts/jxs42uzb_KEC1-01__1_-removebg-preview.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/contact', label: 'Contact' },
  ];

  const services = [
    'Construction & Civil Engineering',
    'Engineering Consulting',
    'Chemical Trading & Imports',
    'Vocational Training',
  ];

  return (
    <footer data-testid="main-footer" className="bg-[#1A2B4A] text-[#F5F5F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <span className="text-2xl font-bold text-white">Kamal Engineers</span>
              <span className="block text-sm text-[#C9A84C]">& Contractors Pvt Ltd</span>
            </div>
            <p className="text-[#F5F5F0]/70 text-sm leading-relaxed mb-6">
              Building India's Future Since 1983. Four decades of engineering excellence in construction, consulting, and turnkey project execution.
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#C9A84C] flex-shrink-0 mt-0.5" />
                <p className="text-sm text-[#F5F5F0]/70">
                  Shree Niketan, 380, Ashok Nagar,<br />
                  Udaipur – 313001, Rajasthan
                </p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-6 text-lg">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(' ', '-')}`}
                    className="footer-link text-sm hover:pl-2 transition-all duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold mb-6 text-lg">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <span className="text-[#F5F5F0]/70 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Info */}
          <div>
            <h4 className="text-white font-bold mb-6 text-lg">Legal Information</h4>
            <div className="space-y-4">
              <div>
                <p className="text-[#C9A84C] text-xs font-bold uppercase tracking-wider mb-1">CIN Number</p>
                <p className="text-[#F5F5F0]/90 text-sm font-mono">U45201RJ1983PTC002692</p>
              </div>
              <div>
                <p className="text-[#C9A84C] text-xs font-bold uppercase tracking-wider mb-1">Registered Office</p>
                <p className="text-[#F5F5F0]/70 text-sm">
                  Shree Niketan, 380, Ashok Nagar,<br />
                  Udaipur – 313001, Rajasthan, India
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#F5F5F0]/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#F5F5F0]/60 text-sm text-center md:text-left">
              © {currentYear} Kamal Engineers and Contractors Pvt Ltd. All rights reserved.
            </p>
            <p className="text-[#F5F5F0]/40 text-xs">
              CIN: U45201RJ1983PTC002692
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
